<template>
  <header class="app-header">
    <div class="header-left">
      <div class="logo" @click="goHome">
        <i class="el-icon-menu" @click.stop="toggleSidebar"></i>
        <span class="logo-text">{{ title }}</span>
      </div>
    </div>
    <div class="header-right">
      <!-- 登录状态判断 -->
      <template v-if="isLoggedIn">
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            <img :src="userAvatar || defaultAvatar" class="avatar" alt="avatar" @error="handleAvatarError">
            <span class="username">{{ username }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile">个人中心</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <!-- 未登录状态 -->
      <template v-else>
        <el-button type="primary" @click="handleLogin">登录</el-button>
      </template>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  props: {
    // 标题
    title: {
      type: String,
      default: 'RippleX'
    },
    // 用户名
    username: {
      type: String,
      default: '用户'
    },
    // 用户头像
    userAvatar: {
      type: String,
      default: ''
    },
    // 是否登录
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultAvatar: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0iI2UwZTBlMCI+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiLz48dGV4dCB4PSI1MCUiIHk9IjU1JSIgZm9udC1zaXplPSIxNiIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPueUtyA8L3RleHQ+PC9zdmc+'
    }
  },
  computed: {
    ...mapState('app', ['sidebarCollapsed'])
  },
  methods: {
    toggleSidebar() {
      this.$store.commit('app/toggleSidebar')
      this.$emit('toggle-sidebar')
    },
    handleCommand(command) {
      this.$emit('command', command)
      switch(command) {
        case 'profile':
          this.$router.push('/profile')
          break
        case 'logout':
          this.$store.dispatch('user/logout')
          // 使用 setTimeout 延迟跳转，让 dropdown 先完成关闭动画
          setTimeout(() => {
            this.$router.push('/login')
          }, 100)
          break
      }
    },
    handleLogin() {
      this.$router.push('/login')
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    handleAvatarError(e) {
      e.target.src = this.defaultAvatar
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  height: 60px;
  background-color: var(--bg-card);
  box-shadow: var(--shadow-sm);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  z-index: 100;

  .header-left {
    .logo {
      display: flex;
      align-items: center;
      cursor: pointer;

      i {
        font-size: 20px;
        margin-right: 10px;
        color: var(--text-primary);
      }

      .logo-text {
        font-size: 18px;
        font-weight: 600;
        color: var(--text-primary);
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: var(--text-primary);

      .avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }
}
</style>
